<app-navigation></app-navigation>
<div class="row mx-0">
    <div class="col col-12 col-lg-12 px-lg-0">
        <router-outlet></router-outlet>
    </div>
</div>